<div class="flex flex-col gap-2">
  @if (loading()) {
  <div class="bg-(--color-bg-secondary) rounded-lg p-3 animate-pulse">
    <div class="flex items-center gap-2 mb-3">
      <div class="w-6 h-6 bg-(--color-bg-primary) rounded"></div>
      <div class="h-4 w-32 bg-(--color-bg-primary) rounded"></div>
    </div>
    <div class="flex flex-wrap gap-2">
      @for (i of [1,2,3,4]; track i) {
      <div class="w-56 rounded-md overflow-hidden bg-(--color-bg-primary) border border-(--color-border)">
        <div class="w-full h-36 bg-(--color-bg-secondary) animate-pulse flex items-center justify-center">
          <mat-icon class="text-4xl w-10 h-10 text-(--color-text-muted)">image</mat-icon>
        </div>
        <div class="p-2 bg-(--color-bg-primary) border-t border-(--color-border)">
          <div class="h-3 w-24 bg-(--color-bg-secondary) rounded mb-1"></div>
          <div class="h-2 w-16 bg-(--color-bg-secondary) rounded"></div>
        </div>
      </div>
      }
    </div>
  </div>
  } @else{
    @for (section of sections(); track section.id) {
    <div class="bg-(--color-bg-secondary) rounded-lg overflow-hidden">
      <div class="flex justify-between items-center p-2.5 cursor-pointer transition-all duration-150 hover:bg-black/3"
        (click)="toggleSection(section.id)">
        <div class="flex items-center gap-2">
          <mat-icon class="text-base w-4 h-4" style="color: var(--color-text-muted)">photo_camera</mat-icon>
          <span class="text-sm font-medium text-(--color-text-primary)">{{ section.name }}</span>
          <span
            class="text-xs font-semibold bg-(--color-bg-primary) text-(--color-text-muted) px-1 py-0.5 rounded-full">{{
            section.images.length }}</span>
        </div>
        <mat-icon class="text-lg w-5 h-5" style="color: var(--color-text-muted)">
          {{ isExpanded(section.id) ? 'expand_less' : 'expand_more' }}
        </mat-icon>
      </div>

      @if (isExpanded(section.id)) {
      <div class="p-2 animate-slideDown">
        <div class="flex flex-wrap gap-2">
          @for (image of section.images; track image.id) {
          <div
            class="image-card relative w-56 rounded-md overflow-hidden bg-(--color-bg-primary) border border-(--color-border) transition-all duration-150 hover:scale-[1.02] hover:shadow-md">
            @if (isSectionLoading(section.id)) {
            <div class="w-full h-36 bg-(--color-bg-secondary) animate-pulse flex items-center justify-center">
              <mat-icon class="text-4xl w-10 h-10 text-(--color-text-muted)">image</mat-icon>
            </div>
            } @else {
            <div class="relative cursor-pointer" (click)="onImageClick(image)">
              <img [src]="getImageUrl(image)" [alt]="image.fileName || 'Evidencia'" class="w-full h-36 object-cover"
                loading="lazy" (error)="onImageError($event, image)" />
              <div class="image-overlay absolute inset-0 bg-black/40 opacity-80 flex items-center justify-center">
                <mat-icon class="text-white text-4xl">zoom_in</mat-icon>
              </div>
            </div>
            }
            <div
              class="flex justify-between items-center p-1.5 bg-(--color-bg-secondary) border-t border-(--color-border)">
              <div class="flex flex-col gap-0.5 min-w-0 flex-1">
                <span class="text-xs font-medium text-(--color-text-primary) truncate">{{ image.fileName }}</span>
                <span class="text-xs text-(--color-text-muted)">{{ image.fileDescription }}</span>
              </div>
              <button
                class="download-btn flex items-center justify-center w-7 h-7 border-none rounded cursor-pointer transition-all duration-150 text-(--color-text-muted) hover:bg-(--color-primary) hover:text-white"
                (click)="onDownload(image, $event)">
                <mat-icon class="text-base w-4 h-4" style="color: inherit">download</mat-icon>
              </button>
            </div>
          </div>
          }
        </div>
      </div>
      }
    </div>
    }
  }
</div>

<!-- Preview Lightbox -->
@if (previewImage()) {
  <div class="fixed inset-0 z-[9999] flex items-center justify-center" style="background-color: rgba(0,0,0,0.9);"
  (click)="closePreview()">
  <div class="max-w-5xl max-h-[90vh] p-4" (click)="$event.stopPropagation()">
    @if (previewLoading()) {
    <div class="flex items-center justify-center h-64">
      <mat-icon class="animate-spin text-6xl text-white">hourglass_empty</mat-icon>
    </div>
    } @else if (previewUrl()) {
    <img [src]="previewUrl()!" alt="Vista previa" class="max-w-full max-h-[80vh] object-contain" />
    } @else {
    <div class="flex items-center justify-center h-64 text-white">
      No se pudo cargar la imagen
    </div>
    }
    <div class="flex justify-between items-center mt-4 px-4">
      <button
        class="flex items-center gap-2 px-4 py-2 rounded text-white transition-colors cursor-pointer hover:opacity-80"
        style="background-color: var(--color-primary);" (click)="onDownload(previewImage()!, $event)">
        <mat-icon class="text-white">download</mat-icon>
        <span>Descargar</span>
      </button>
      <button class="flex items-center gap-2 px-4 py-2 rounded text-white transition-colors cursor-pointer"
        style="background-color: rgba(255,255,255,0.1);" (click)="closePreview()">
        <mat-icon class="text-white">close</mat-icon>
        <span>Cerrar</span>
      </button>
    </div>
  </div>
</div>
}